import { get } from "@/services/http/backend";
import { PagedResult } from "./types";

export enum CompanyLogOperationType {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
  UPDATE_DO_NOT_INCREASE_QUANTITY_WHEN_RECYCLE = "UPDATE_DO_NOT_INCREASE_QUANTITY_WHEN_RECYCLE",
}

export enum CompanyLogTargetType {
  USER = "USER",
  COMPANY = "COMPANY",
  SHARED_EWAYBILL_SHIPPING_ADDRESS = "SHARED_EWAYBILL_SHIPPING_ADDRESS",
  EWAYBILL_ACCOUNT = "EWAYBILL_ACCOUNT",
}

export interface CompanyLog {
  id: number;
  companyId: number;
  userId: number;
  username: string;
  nickName: string;
  operationType: CompanyLogOperationType;
  description: string;
  targetId: number;
  clientIp: string;
  dateCreated: string;
}

interface GetCompanyLogParams {
  pageNo: number;
  pageSize: number;
  targetId?: number;
  targetType?: CompanyLogTargetType;
}

export async function getCompanyLogs(params: GetCompanyLogParams) {
  return get<PagedResult<CompanyLog>>("/company_logs", params);
}
